import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useCallback, useContext, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function useRequestAccess(
  shareableLinkId: string,
  requestedAccessAt: Date,
) {
  const [hasRequestOrReminderSent, setHasRequestOrReminderSent] =
    useState(false);

  const { popSuccess, popServerError } = useContext(PopNotificationsContext);

  const hasAlreadyRequestedAccess = useMemo(
    () => !!requestedAccessAt,
    [requestedAccessAt],
  );

  const { t } = useTranslation();

  const onSendReminder = useCallback(async () => {
    try {
      setHasRequestOrReminderSent(true);
      await api.shareableLinks.requestAccessReminder(shareableLinkId);
      popSuccess(t('reminderSentSuccesfully'));
    } catch (e) {
      popServerError(e);
      setHasRequestOrReminderSent(false);
    }
  }, [shareableLinkId, popSuccess, t, popServerError]);

  const onRequestAccess = useCallback(async () => {
    try {
      setHasRequestOrReminderSent(true);
      await api.shareableLinks.requestAccess(shareableLinkId);
      popSuccess(t('yourAccessRequestubmittedSuccessfully'));
    } catch (e) {
      popServerError(e);
      setHasRequestOrReminderSent(false);
    }
  }, [shareableLinkId, popSuccess, t, popServerError]);

  return {
    hasAlreadyRequestedAccess,
    hasRequestOrReminderSent,
    onSendReminder,
    onRequestAccess,
  };
}
